import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Outlet } from 'react-router-dom';
import { Routes, Route } from "react-router-dom"

// 페이지 import
import FooterInformation from "../pages/footer/Footer-Information"
import FooterAccess from '../pages/footer/Footer-Access';
import FooterContact from "../pages/footer/Footer-Contact"

// 아이콘 import
import { AiOutlineInstagram } from "react-icons/ai"; 



const Footer = () => {
   const activeStyle={color:'lavender',}
   return (
      <>
         <div className='inner'>
            <div className='FooterOutlet'>
               <Outlet/>
               <Routes>
                  <Route path="/FooterInformation" element={<FooterInformation/>}></Route>
                  <Route path="/FooterAccess" element={<FooterAccess/>}></Route>
                  <Route path="/FooterContact" element={<FooterContact/>}></Route>
               </Routes>
            </div>
         </div>
         <div id='Footer'>

            <div className='CompanyInfo'>
               <p>LCDC SEOUL</p>
               <span>서울 성동구 연무장17길 10</span>
               <span className='mb30'>10, Yeonmujang 17-gil, Seongdong-gu, Seoul, Republic of Korea</span>
               <p>월요일 - 일요일</p>
               <span>1F    CAFE EPHEMERA    |    11:00AM ~ 20:00PM</span>
               <span>2F    SHOP LCDC    |    11:00AM ~ 20:00PM</span>
               <span>3F    TENANT    |    11:00AM ~ 20:00PM (업체별 상이)</span>
               <span className='mb30'>4F    BAR POSTSCRIPT    |    11:30AM ~ 00:00AM</span>
               <div>
                  <div>
                     <a href="noscript:"><em>SITE</em></a>
                     <a href="noscript:"><em>GUIDE</em></a>
                  </div>
                  <span>COPYRIGHT © 2023 LCDC SEOUL</span>
               </div>
            </div>

            <ul className="FooterNav">
                <li><NavLink to="/FooterInformation" style={({isActive}) => (isActive ? activeStyle: undefined)}>INFORMATION</NavLink></li>
                <li><NavLink to="/FooterAccess" style={({isActive}) => (isActive ? activeStyle: undefined)}>ACCESS</NavLink></li>
                <li><NavLink to="/FooterContact" style={({isActive}) => (isActive ? activeStyle: undefined)}>CONTACT</NavLink></li>
            </ul>

            <div className='sns flexCenter'>
               <img src={require("../img/logo_black.png")} alt="" />
               <Link to="https://www.instagram.com/lcdc.seoul/" target='_black'><AiOutlineInstagram /></Link>
            </div>

         </div>
      </>
   );
};

export default Footer;